var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _g2, _g3, _g4, _path8, _path9, _path0, _path1, _g5, _path10, _path11, _path12, _g6, _path13, _g7, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _g8, _path30, _g9, _path31, _path32, _path33, _path34, _path35, _tspan, _path36, _g0, _g1, _g10, _g11, _g12, _g13, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _g14, _g15, _g16, _g17, _path47, _g18, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 185.21 185.21",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(244.17 202.68)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(708.39 -1395.2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-172.91-1050.9c3.3988-2.5377 2.9992-7.8285 0-10.828l-36.204-36.204c-2.9992-2.9992-7.8283-2.9992-10.828 0l-117.35 117.15c-3.0259 18.772-6.1309 37.622-9.1569 56.394l56.182-9.3684c30.372-30.373 44.725-44.671 59.211-59.103 14.486-14.432 28.733-28.625 58.15-58.041z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 6.2,
    strokeWidth: 9.2604,
    style: {
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(-.7071 .70711 -.7071 -.70711 0 0)",
    x: -601.16,
    y: 865.36,
    width: 11.067,
    height: 67.307,
    ry: 5.0819,
    style: {
      paintOrder: "normal"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m-312.87-925.23-32.298-32.298-1.2759 33.122z"
  })), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(-.7071 .70711 -.7071 -.70711 0 0)",
    x: -467.45,
    y: 865.78,
    width: 11.067,
    height: 67.307,
    ry: 5.0819,
    style: {
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-22.725 -737.99)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: -352.56,
    cy: -1716.3,
    rx: 5.3342,
    ry: 5.342,
    style: {
      paintOrder: "normal"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m-352.56-1698.5v37.858",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.2604
  })), /*#__PURE__*/React.createElement("path", {
    d: "m-436.72-1743.3c-2.1093 0-3.8075 1.7045-3.8075 3.8223v103.57c0 2.1178 1.6982 3.8231 3.8075 3.8231h23.241v36.286l71.375-36.286h73.718c2.1091 0 3.8076-1.7053 3.8076-3.8231v-103.57c0-2.1178-1.6984-3.8223-3.8076-3.8223z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 6.2,
    strokeWidth: 9.2604,
    style: {
      paintOrder: "normal"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(556.43 -843.57)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.2604
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1850-304.31h41.122l69.633-108.8h65.031"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-1674.2-413.11-39.659-19.993"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-1674.2-413.11-39.659 19.993"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-1674.2-304.31-39.659-19.993"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-1674.2-304.31-39.659 19.993"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-1850-413.11h41.122l69.633 108.8h65.031"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-396.86 -1264.9)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.2604
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-867.12-414.19h104.67c3.3728 0 6.0881 2.7049 6.0881 6.0648v144.09c0 3.3599-2.7154 6.0648-6.0881 6.0648h-104.67c-3.3729 0-6.0882-2.7049-6.0882-6.0648v-144.09c0-3.3599 2.7154-6.0648 6.0882-6.0648z",
    strokeMiterlimit: 6.2,
    style: {
      paintOrder: "normal"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m-872.76-428.6h116.32"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m-847.83-394.01v115.87"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m-814.78-394.01v115.87"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m-781.73-394.01v115.87"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m-831.69-433.91h34.159"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1842.2 -908.83)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-508.09-666.26-2.7e-4 50.635c0 1.2636-0.84285 2.2808-1.8901 2.2808h-172.17c-1.0471 0-1.8901-1.0172-1.8901-2.2808v-50.635",
    strokeMiterlimit: 6.2,
    strokeWidth: 9.2604,
    style: {
      paintOrder: "normal"
    }
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 -1 -440.27 -837.78)",
    strokeWidth: 9.2604
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-155.8-47.138v-150.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-155.8-197.97-43.482 44.424"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-155.8-197.97 43.482 44.424"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1852.4 -902.06)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.2604
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-190.14-620.9-1.6e-4 -175.78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-155-620.8-70.286-1.5e-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-154.99-796.78-70.286-1.5e-4"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(150.4 -731.41)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.2604
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1004.9-1676.1h175.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-1004.9-1735.3h175.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-1004.9-1616.9h175.82"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.4022 0 0 1.4556 666.01 -1856)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6.4819
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-127.05-111.19v84.94h-97.204v-120.69h59.76",
    strokeMiterlimit: 6.2,
    style: {
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-128.34-109.95h-36.15c-0.71698 0-1.2941-0.55098-1.2941-1.2354v-34.51c0-0.6844 0.57712-1.2354 1.2941-1.2354l37.444 35.745c0 0.68441-0.57721 1.2354-1.2941 1.2354z",
    style: {
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.4034 0 0 1.3953 -518.94 -1492)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.82035 0 0 .81915 -1000.8 8.5909)",
    strokeWidth: 8.0728
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1064-145.82v108.35h-118.37v-153.95h72.773",
    strokeMiterlimit: 6.2,
    style: {
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1062.5-144.25h-44.021c-0.8731 0-1.5759-0.70284-1.5759-1.5759v-44.021c0-0.87303 0.7028-1.5759 1.5759-1.5759l45.597 45.597c0 0.87304-0.7029 1.5759-1.5759 1.5759z",
    style: {
      paintOrder: "normal"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m-203.73-65.836h56.15",
    strokeWidth: 6.6177
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m-203.73-86.588h56.15",
    strokeWidth: 6.6177
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "m-203.73-45.084h56.15",
    strokeWidth: 6.6177
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(604.6 -721.44)",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1479.3-1348.6h131.96c14.662 14.662 29.325 29.325 43.987 43.987v131.96h-175.95v-175.95z",
    strokeWidth: 9.2604,
    style: {
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1427.7,
    y: -1348.6,
    width: 72.677,
    height: 47.425,
    strokeWidth: 9.2604,
    style: {
      paintOrder: "normal"
    }
  }), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "m-1377.4-1332.9v15.495",
    strokeLinecap: "round",
    strokeWidth: 9.2604
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.1522 0 0 1.1522 2485.6 -1321)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -3414,
    y: 67.181,
    width: 98.601,
    height: 61.57,
    strokeWidth: 8.037,
    style: {
      paintOrder: "normal"
    }
  }), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: 8.037
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-3332.2 86.816h-64.935"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-3332.2 109.12h-64.935"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1226.4 -2041.9)",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-270.94-413.34v22.494m-104.46 0v-62.721h64.22",
    strokeMiterlimit: 6.2,
    strokeWidth: 9.2604,
    style: {
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-272.33-411.95h-38.847c-0.77048 0-1.3907-0.62007-1.3907-1.3903v-38.837c0-0.77021 0.62019-1.3903 1.3907-1.3903l40.238 40.227c0 0.77021-0.62029 1.3903-1.3907 1.3903z",
    strokeLinecap: "round",
    strokeWidth: 9.2604,
    style: {
      paintOrder: "normal"
    }
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m-263.93-373.52h12.752",
    strokeLinecap: "round",
    strokeWidth: 9.2604
  })), /*#__PURE__*/React.createElement("path", {
    d: "m-374.82-325.25h-36.321v-64.504h175.95v64.504h-33.492",
    strokeWidth: 9.2604,
    style: {
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-171.6 -248.73)"
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m-181.74-68.86h60.34",
    strokeLinecap: "round",
    strokeWidth: 9.2604
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m-181.74-50.007h60.34",
    strokeLinecap: "round",
    strokeWidth: 9.2604
  })), /*#__PURE__*/React.createElement("rect", {
    x: -204.64,
    y: -89.977,
    width: 106.13,
    height: 61.087,
    strokeWidth: 9.2604,
    style: {
      paintOrder: "normal"
    }
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-651.26 -907.69)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.2604
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1479.2 143.77 175.85-175.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-1479.2-32.087 175.85 175.85"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(238.13 -1067.8)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.2604
  }, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(.70704 -.70717 .70704 .70717 0 0)",
    cx: -344.67,
    cy: -2283.1,
    rx: 57.372,
    ry: 56.435,
    style: {
      paintOrder: "normal"
    }
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m-1738.9-1251.8-79.106-79.12"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(986.16 -854.73)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-925.98-1197h-35.149v-18.316h35.149z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 6.2,
    strokeWidth: 9.2604,
    style: {
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-791.99 -1017.3)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 6.2,
    strokeWidth: 9.2604
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-80.133-22.106h-142.87v-157.63h142.87z",
    style: {
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-106.55-167.14h-90.033v-6.8892h90.033z",
    style: {
      paintOrder: "normal"
    }
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.1649 0 0 1.1627 3430.2 -880.55)",
    strokeWidth: 0.85924
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7.9569
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-3788.4-212.56h68.377"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-3788.4-237.18h68.377"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-3788.4-187.93h68.377"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-3789-163.31h68.377"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1784.9 -907.88)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(.50751 -.86165 .87029 .49253 0 0)",
    cx: 704.22,
    cy: -258.7,
    rx: 23.977,
    ry: 23.822,
    strokeWidth: 9.2611,
    style: {
      paintOrder: "normal"
    }
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m185.26-702.97-32.842-18.587",
    strokeWidth: 9.2604
  })), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(.50751 .86165 .87029 -.49253 0 0)",
    cx: -519.54,
    cy: 454.94,
    rx: 23.977,
    ry: 23.822,
    strokeWidth: 9.2611,
    style: {
      paintOrder: "normal"
    }
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m185.26-702.97-32.842 18.587",
    strokeWidth: 9.2604
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m185.27-702.97 98.805-29.777",
    strokeWidth: 9.2604
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m185.27-702.97 98.805 29.777",
    strokeWidth: 9.2604
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-375.21 -976.97)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.65704
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.5227 0 0 1.5212 447.42 -646.11)"
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.26458 0 0 .26458 -244.17 -97.607)",
    d: "m-5468.3 2139.3-1e-4 -72.696",
    strokeLinejoin: "round",
    strokeWidth: 22.997
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.26458 0 0 .26458 -244.17 -97.607)",
    d: "m-5468.3 2503.4-2e-4 -246.96",
    strokeLinejoin: "round",
    strokeWidth: 22.997
  })), /*#__PURE__*/React.createElement("circle", {
    cx: -1691,
    cy: 483.92,
    r: 15.502,
    strokeLinejoin: "bevel",
    strokeWidth: 6.0845,
    style: {
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.5227 0 0 1.5212 449.93 -646.11)"
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.26458 0 0 .26458 -244.17 -97.607)",
    d: "m-5314.8 2305.2-1e-4 -238.62",
    strokeLinejoin: "round",
    strokeWidth: 22.997
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.26458 0 0 .26458 -244.17 -97.607)",
    d: "m-5314.8 2503.4-2e-4 -81.033",
    strokeLinejoin: "round",
    strokeWidth: 22.997
  })), /*#__PURE__*/React.createElement("circle", {
    cx: -1650.4,
    cy: 527.82,
    r: 15.502,
    strokeLinejoin: "bevel",
    strokeWidth: 6.0845,
    style: {
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.5227 0 0 1.5212 405.23 -644.49)"
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.26458 0 0 .26458 -244.17 -97.607)",
    d: "m-5044 2186.7v-124.14",
    strokeLinejoin: "round",
    strokeWidth: 22.997
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.26458 0 0 .26458 -244.17 -97.607)",
    d: "m-5044 2499.4v-195.51",
    strokeLinejoin: "round",
    strokeWidth: 22.997
  })), /*#__PURE__*/React.createElement("circle", {
    cx: -1578.7,
    cy: 496.46,
    r: 15.502,
    strokeLinejoin: "bevel",
    strokeWidth: 6.0845,
    style: {
      paintOrder: "normal"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-228.23 -219.41)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.2604
  }, /*#__PURE__*/React.createElement("rect", {
    x: -2262.1,
    y: -1850.6,
    width: 116.03,
    height: 175.95,
    strokeMiterlimit: 6.2,
    style: {
      paintOrder: "normal"
    }
  }), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m-2212.1-1762.7h132.04"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m-2080.1-1762.7-38.889 38.051"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m-2080.1-1762.7-38.889-38.051"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-215.53 -196.22)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.2604
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1895.2,
    y: -1873.8,
    width: 116.03,
    height: 175.95,
    strokeMiterlimit: 6.2,
    style: {
      paintOrder: "normal"
    }
  }), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m-1713.1-1785.9h-132.04"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m-1845.2-1785.9 38.889 38.051"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m-1845.2-1785.9 38.889-38.051"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1893.3 -908.48)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-822.95-666.6-2.7e-4 50.635c0 1.2636-0.84285 2.2808-1.8901 2.2808h-172.17c-1.0471 0-1.8901-1.0172-1.8901-2.2808v-50.635",
    strokeMiterlimit: 6.2,
    strokeWidth: 9.2604,
    style: {
      paintOrder: "normal"
    }
  }), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-755.12 -593.01)",
    strokeWidth: 9.2604
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-155.8-47.138v-150.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-155.8-197.97-43.482 44.424"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-155.8-197.97 43.482 44.424"
  })))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m292.2-1203.9h175.78",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.2604
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(152.4 -1113.4)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.2604
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-239.46-110.08h175.78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-151.57-197.97v175.78"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-401.08 -1192.9)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.2604
  }, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(.70704 -.70717 .70704 .70717 0 0)",
    cx: -840.6,
    cy: -2602.2,
    rx: 57.372,
    ry: 56.435,
    style: {
      paintOrder: "normal"
    }
  }), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m-2315.2-1126.7-79.106-79.12"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "m-2472.2-1245.8h76.099"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m-2434.2-1283.8v76.099"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(63.361 -1102)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.2604
  }, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(.70704 -.70717 .70704 .70717 0 0)",
    cx: -566.18,
    cy: -2456.3,
    rx: 57.372,
    ry: 56.435,
    style: {
      paintOrder: "normal"
    }
  }), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "m-2018-1217.6-79.106-79.12"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "m-2175-1336.6h76.099"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-7.4496 -822.12)"
  }, /*#__PURE__*/React.createElement("text", {
    x: -2507.1326,
    y: -1592.7974,
    fill: "#000000",
    fontFamily: "sans-serif",
    fontSize: "64.968px",
    letterSpacing: "0px",
    strokeWidth: 0.26458,
    wordSpacing: "0px",
    style: {
      lineHeight: 3.3499999
    },
    xmlSpace: "preserve"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    transform: "matrix(.69682 0 0 .69682 -67.154 -55.007)",
    x: -2507.1326,
    y: -1592.7974,
    dx: 0,
    dy: 0,
    fontFamily: "Verdana",
    letterSpacing: "-11.877px",
    strokeWidth: 0.3797
  }))), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(.70704 -.70717 .70704 .70717 0 0)",
    cx: -598.09,
    cy: -2883.9,
    rx: 57.372,
    ry: 56.435,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.2604,
    style: {
      paintOrder: "normal"
    }
  }), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "m-2342.9-1497.5-79.106-79.12",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.2604
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3120.9 -421.05)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 6.2,
    strokeWidth: 9.2604
  }, /*#__PURE__*/React.createElement("rect", {
    x: 228.71,
    y: -496.78,
    width: 153.95,
    height: 153.95,
    style: {
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m250.71-496.78v-22.001h153.95v153.95h-22.001",
    style: {
      paintOrder: "normal"
    }
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-312.38 -1532.9)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.2604
  }, /*#__PURE__*/React.createElement("path", {
    d: "m392.74-12.279h-71.21c-61.035 0-61.035-93.208 5.2019-93.208h125.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m452.29-105.49-38.889 38.051"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m452.29-105.49-38.889-38.051"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(56.755 -1230.3)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.2604
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-460.41-314.9h71.21c61.035 0 61.035-93.208-5.2019-93.208h-125.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-519.95-408.11 38.889 38.051"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-519.95-408.11 38.889-38.051"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1808.6 -1076.8)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.2604
  }, /*#__PURE__*/React.createElement("path", {
    d: "m184.03-110.91-95.204 87.928"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m184.03-110.91-95.204-87.928"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-19.844 257.14)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.2604
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-179.33-367.22 95.204 87.928"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-179.33-367.22 95.204-87.928"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(164.24 -1072.4)",
    fill: "none",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026 0 0 1.0256 -467.17 -277.97)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.0272
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-158.47 96.672 38.889 38.051"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-158.47 96.672 38.889-38.051"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m-629.8-110.39c0 27.681 16.681 52.636 42.264 63.229 25.583 10.593 55.031 4.7377 74.611-14.836 19.58-19.573 25.438-49.01 14.841-74.584-10.597-25.574-35.13-42.246-62.821-42.246l-68.842 3e-3",
    strokeWidth: 9.2604
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m-1515-863.95h-175.95l90.042-75.866zm-106.82 100.07h-46.533v-100.07h129.18v100.07h-46.533m-36.114-0.1181v-48.059h36.115v48.059",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.2604,
    style: {
      paintOrder: "normal"
    }
  }), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-24.145 -1106.2)",
    fill: "none",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.026 0 0 1.0256 -903.17 -277.97)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.0272
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-158.47 96.672 38.889 38.051"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-158.47 96.672 38.889-38.051"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m-740.53-110.39c0 27.681-16.681 52.636-42.264 63.229-25.583 10.593-55.031 4.7377-74.611-14.836-19.58-19.573-25.438-49.01-14.841-74.584 10.597-25.574 35.13-42.246 62.821-42.246l68.842 3e-3",
    strokeWidth: 9.2604
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-240.95 -1137.5)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.2604
  }, /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(45)",
    cx: -690.9,
    cy: -1105.2,
    r: 87.974,
    style: {
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(45)",
    cx: -690.9,
    cy: -1105.2,
    r: 59.536,
    style: {
      paintOrder: "normal"
    }
  }), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "m335.03-1227.9 20.05 20.05"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "m230.78-1332.2 20.05 20.05"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "m250.83-1227.9-20.05 20.05"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "m355.08-1332.2-20.05 20.05"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-291.47 -1158.5)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.2604
  }, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-9.6139e-5 -1 1 9.0482e-5 0 0)",
    cx: 452.4,
    cy: 693.55,
    rx: 31.199,
    ry: 31.635,
    style: {
      paintOrder: "normal"
    }
  }), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "m837.76-452.34-112.59-6e-3"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "m781.1-426.26 6e-3 -26.058"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "m799.03-430.78 6e-3 -21.572"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "m816.96-426.28 6e-3 -26.058"
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.62427 0 0 .62366 895.35 -1173.3)",
    d: "m-112.51-183.04 38.32 95.424 102.6 6.9565-78.912 65.932 25.088 99.723-87.09-54.676-87.09 54.676 25.088-99.723-78.912-65.932 102.6-6.9565z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 14.841,
    style: {
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.4089 -1533.7)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(.50751 -.86165 .87029 .49253 0 0)",
    cx: 518.3,
    cy: 619.6,
    rx: 23.977,
    ry: 23.822,
    strokeWidth: 9.2611,
    style: {
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(.50751 -.86165 .87029 .49253 0 0)",
    cx: 406.42,
    cy: 684.84,
    rx: 23.977,
    ry: 23.822,
    strokeWidth: 9.2611,
    style: {
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(.50751 -.86165 .87029 .49253 0 0)",
    cx: 525.33,
    cy: 762.39,
    rx: 23.977,
    ry: 23.822,
    strokeWidth: 9.2611,
    style: {
      paintOrder: "normal"
    }
  }), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "m827.84-128.57 76.633 38.525",
    strokeWidth: 9.2604
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "m823.82-23.72 84.739-42.6",
    strokeWidth: 9.2604
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(90 -767.89 -2037.6)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.2604
  }, /*#__PURE__*/React.createElement("path", {
    d: "m18.239-367.22 95.204-87.928"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.239-367.22 95.204 87.928"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -1 -1 0 -2440.6 -1139.8)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.2604
  }, /*#__PURE__*/React.createElement("path", {
    d: "m18.239-367.22 95.204-87.928"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.239-367.22 95.204 87.928"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-516.09 -545.51)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2502.5 196.93)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 9.2604
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1989.1 -136.04)",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-179.33-367.22 95.204-62.484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-179.33-367.22 95.204 62.484"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m1800.4-591.2v175.86"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-398.89 -550.17)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 9.2604
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 -537.45 65.543)",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-179.33-367.22 95.204-62.484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-179.33-367.22 95.204 62.484"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m-348.82-389.61v175.86"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1422.8 -675.92)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.2604
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: -1833.9,
    cy: -222.46,
    rx: 41.306,
    ry: 41.449,
    style: {
      paintOrder: "normal"
    }
  }), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "m-1921.6-88.029h175.41m-175.41 2e-6a87.974 86.257 0 0 1-0.2678-6.7243 87.974 86.257 0 0 1 87.974-86.257 87.974 86.257 0 0 1 87.974 86.257 87.974 86.257 0 0 1-0.2679 6.726"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m67.944-879.66c-5.379-20.224-23.863-34.319-45.004-34.319-1.6883 0-3.3754 0.0908-5.0537 0.27224m-39.874 34.013c-0.5235-0.0196-1.0473-0.0294-1.5711-0.0294-22.901-1e-5 -41.466 18.364-41.466 41.017 0 9.8464 2.1625 21.359 10.074 26.799 42.647 29.321 113.17 29.327 155.81 2e-5 7.9097-5.4399 10.065-16.952 10.065-26.799 0-22.653-18.565-41.017-41.466-41.017-0.5238 0-1.0476 0.01-1.5711 0.0294m-89.932 0.034c5.379-20.224 23.863-34.319 45.004-34.319 1.6883 0 3.3754 0.0908 5.0537 0.27224",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.2604,
    style: {
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: -429.93,
    y: -2070.1,
    width: 175.95,
    height: 175.95,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.2604,
    style: {
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(108.07 -1823.6)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.2604
  }, /*#__PURE__*/React.createElement("rect", {
    x: -516.69,
    y: -200.04,
    width: 25.929,
    height: 25.929,
    style: {
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: -462.98,
    y: -200.04,
    width: 25.929,
    height: 25.929,
    style: {
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: -409.27,
    y: -200.04,
    width: 25.929,
    height: 25.929,
    style: {
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: -516.69,
    y: -142.89,
    width: 25.929,
    height: 25.929,
    style: {
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: -462.98,
    y: -142.89,
    width: 25.929,
    height: 25.929,
    style: {
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: -409.27,
    y: -142.89,
    width: 25.929,
    height: 25.929,
    style: {
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: -429.93,
    y: -2051.8,
    width: 175.95,
    height: 139.34,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.2604,
    style: {
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-65.371 -968.71)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.2604
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1630.5,
    y: -1101.3,
    width: 116.03,
    height: 175.95,
    strokeMiterlimit: 6.2,
    style: {
      paintOrder: "normal"
    }
  }), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m-1696.6-1013.4h132.04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-1564.5-1013.4-38.889 38.051"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-1564.5-1013.4-38.889-38.051"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1196.1 623.79)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.2604
  }, /*#__PURE__*/React.createElement("rect", {
    x: -2486.7,
    y: -2693.8,
    width: 116.03,
    height: 175.95,
    strokeMiterlimit: 6.2,
    style: {
      paintOrder: "normal"
    }
  }), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "m-2420.6-2605.9h-132.04"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "m-2552.7-2605.9 38.889 38.051"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "m-2552.7-2605.9 38.889-38.051"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-131.23 -432.6)"
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "m510.39-419.25h99.06",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.2604
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "m510.39-478.44h99.06",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.2604
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "m510.39-360.07h99.06",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.2604
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 491.24,
    cy: -478.44,
    r: 4.6302,
    style: {
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 491.24,
    cy: -419.25,
    r: 4.6302,
    style: {
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 491.24,
    cy: -360.07,
    r: 4.6302,
    style: {
      paintOrder: "normal"
    }
  }), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "m433.62-419.25h38.456",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.2604
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "m433.62-478.44h38.456",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.2604
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "m433.62-360.07h38.456",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.2604
  }))), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "m-2794.5-2031.1c-7.0159-7.7603-14.032-15.521-21.048-23.281h-35.36m-32.911 23.281c7.0159-7.7603 14.032-15.521 21.048-23.281h35.36m111.22 144.57h-175.95v-121.29h175.95v121.29z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.2604
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 744.32,
    y: -2034.9,
    width: 175.95,
    height: 105.58,
    strokeWidth: 9.2604,
    style: {
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m920.27-2034.9-175.96-0.3367 87.691 78.011z",
    strokeWidth: 9.2604,
    style: {
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m803.85-1981.9-59.539 52.967 175.96-0.3369-59.796-52.617-28.461 25.044z",
    strokeWidth: 9.2604,
    style: {
      paintOrder: "normal"
    }
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "m-1185.8-2341.6v-133.06h-42.622v155.07h61.812v-175.94h-83.077v153.94",
    fill: "none",
    stroke: "#000",
    strokeWidth: 9.2604
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-30.108 -18.972)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.2604
  }, /*#__PURE__*/React.createElement("path", {
    d: "m763.42-840.02a150.89 154.11 0 0 1 50.689-8.9567 150.89 154.11 0 0 1 50.686 8.9558",
    style: {
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m744.76-872.99a187.69 191.7 0 0 1 69.355-13.568 187.69 191.7 0 0 1 69.338 13.561",
    style: {
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m726.19-905.84a224.49 229.29 0 0 1 87.901-18.308 224.49 229.29 0 0 1 87.923 18.318",
    style: {
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 814.1,
    cy: -798.32,
    rx: 18.761,
    ry: 18.767,
    style: {
      paintOrder: "normal"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.2abf9eec2eb9b4dd38ba7f7c4b5909b7.svg";
export { ForwardRef as ReactComponent };